import React from 'react';
import { observer } from 'mobx-react';
import { Form, Message, Button } from 'semantic-ui-react';

import SSMForm from '#/shared/forms/_.extend';

import FormControls from './controls/FormControls';

const AuthFormRegister = observer(({ form }: { form: SSMForm }) => (
  <Form>
    <Message
      content={
        <span>
          If you are a Shiftsmart partner, please download our Partner app on
          your app store or at{' '}
          <Button
            basic={true}
            className="link"
            content="Shiftsmart.com"
            onClick={() => {
              window.location.href = 'https://shiftsmart.com/worker-sign-up';
            }}
            primary={true}
            style={{
              padding: '0.25rem',
            }}
          />
        </span>
      }
      icon="info circle"
      info={true}
    />
    <form.Field fieldKey="email" type="email" />
    <form.Field fieldKey="password" type="password" />
    <form.Field fieldKey="passwordConfirm" type="password" />
    <FormControls
      controls={{ onSubmit: true }}
      form={form}
      labels={{ submit: 'Register' }}
    />
    <p className="red">{form.error}</p>
  </Form>
));

export default AuthFormRegister;
